import Loader from './Loader'

Loader.install = (Vue, options) => {
  Vue.component(Loader.name, Loader)
}
export default Loader


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Loader/index.js
// module id = null
// module chunks = 